<template>
  <div
    v-if="!tooltip || tooltip.length === 0"
    @click.stop="$emit('action')"
    class="action-container"
    :class="{ showAlways }"
  >
    <v-icon :style="{ color: primaryColor }">
      {{ icon }}
    </v-icon>
  </div>
  <v-tooltip top v-else>
    <template v-slot:activator="{ on }">
      <div
        @click.stop="$emit('action')"
        class="action-container"
        :class="{ showAlways }"
        v-on="on"
      >
        <v-icon :style="{ color: primaryColor }">
          {{ icon }}
        </v-icon>
      </div>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue"
import Theme from "constants/theme"
import {
  useIsBreakpointInNames,
  useVuetifyBreakpointName,
} from "features/common/vuetify/useVuetify"

export default defineComponent({
  name: "GalleryThumbnailActionButton",
  props: {
    icon: {
      type: String,
      required: true,
    },
    showAlways: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const isSmallerDevice = useIsBreakpointInNames(["xs", "sm", "md"])
    const _showAlways = computed(() =>
      isSmallerDevice.value ? true : props.showAlways
    )

    return {
      primaryColor: Theme.colors.light.primary,
      showAlways: _showAlways,
    }
  },
})
</script>

<style scoped>
.action-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  padding: 4px;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.action-container.showAlways {
  opacity: 1;
}
</style>
